import React from "react";
import { PostStepProps } from "../Detail";
import { Button, Col, Image, Row, Space, Tag, Typography } from "antd";
import { useHistory } from "react-router-dom";
import DetailItem from "../../../../components/DetailItem";
import NotSet from "../../../../components/NotSet";
import { formatYearToTime } from "../../../../helpers/format";
import { EArticleStatus } from "../../../../types/blog.type";
import { getFullName } from "../../../../helpers/name";

const DetailDetailPost: React.FC<PostStepProps> = ({ articleId, post }) => {
	const history = useHistory();

	return (
		<>
			<Row
				gutter={[24, 0]}
				className="detail-bordered"
			>
				<Col span={24}>
					<DetailItem
						label="Post Title"
						value={post?.title}
						renderValue={(v) => (
							<Space direction="vertical">
								<Typography.Text>{v}</Typography.Text>
							</Space>
						)}
					/>
				</Col>
				<Col span={24}>
					<DetailItem
						label="Meta Description"
						value={post?.subtitle}
					/>
				</Col>

				<Col
					span={24}
					md={12}
				>
					<DetailItem label="Categories">
						<Space wrap>
							{(post?.categories ?? [])?.length! > 0 ? (
								post?.categories.map((category) => {
									return (
										<Tag color="blue">
											{category.parentCategory.categoryName}{" "}
											{category.categoryId && `(${category.category.categoryName})`}
										</Tag>
									);
								})
							) : (
								<NotSet />
							)}
						</Space>
					</DetailItem>
				</Col>
				<Col
					span={24}
					md={12}
				>
					<DetailItem label="Tags">
						<Space>
							{post?.tags && post?.tags.length > 0 ? (
								post?.tags?.map((tag) => <Tag color="green">{tag.tag.tagName}</Tag>)
							) : (
								<NotSet />
							)}
						</Space>
					</DetailItem>
				</Col>

				<Col span={24}>
					<DetailItem label="Images">
						{post?.images && post?.images?.length > 0 ? (
							post?.images?.map((file) => (
								<Image
									width={190}
									height={170}
									src={file?.imageUrl || "/images/no-preview.jpg"}
									style={{
										borderRadius: 8,
										objectFit: "cover",
									}}
								/>
							))
						) : (
							<NotSet />
						)}
					</DetailItem>
				</Col>

				<Col
					span={24}
					md={8}
				>
					<DetailItem
						label={`Publish ${post?.status === EArticleStatus.SCHEDULED ? "Scheduled" : ""} At`}
						value={formatYearToTime(post?.publicationAt)}
					/>
				</Col>

				<Col
					span={24}
					md={8}
				>
					<DetailItem
						label="Blog Admin"
						value={getFullName(post?.user)}
					/>
				</Col>

				<Col
					span={24}
					md={8}
				>
					<DetailItem
						label="Author/Editor Name"
						value={post?.authorName}
					/>
				</Col>
			</Row>
			<Row gutter={[24, 0]}>
				<Col
					span={24}
					style={{ height: 20 }}
				></Col>

				<Col span={12}>
					<Button
						disabled
						className="btn-fixed-lg"
					>
						Previous
					</Button>
				</Col>
				<Col
					span={12}
					style={{ textAlign: "right" }}
				>
					<Button
						type="primary"
						className="btn-fixed-lg"
						onClick={() => history.replace("/blog-posts/" + articleId + "/description-post")}
					>
						Next
					</Button>
				</Col>
			</Row>
		</>
	);
};

export default DetailDetailPost;
